import { Outlet, Navigate } from "react-router-dom";

const TapeRoutes = (props) => {
  return props.tapeUser ? <Outlet /> : <Navigate to="/" />;
};

export default TapeRoutes;
